/**
 * Runtime configuration module.
 *
 * In Docker, entrypoint.sh generates /env-config.js which sets window._env_.
 * During local dev (npm start), window._env_ is undefined so we fall back
 * to process.env which CRA injects at build time.
 */
const env = window._env_ || {};

const get = (key) => env[key] || process.env[key];

const config = {
  REACT_APP_COGNITO_URL: get('REACT_APP_COGNITO_URL'),
  REACT_APP_COGNITO_CLIENT_ID: get('REACT_APP_COGNITO_CLIENT_ID'),
  REACT_APP_COGNITO_CLIENT_SECRET: get('REACT_APP_COGNITO_CLIENT_SECRET'),
  REACT_APP_COGNITO_SIGNIN: get('REACT_APP_COGNITO_SIGNIN'),
  REACT_APP_COGNITO_SIGNOUT: get('REACT_APP_COGNITO_SIGNOUT'),
  REACT_APP_COGNITO_SCOPE: get('REACT_APP_COGNITO_SCOPE'),
  REACT_APP_COGNITO_RESPONSE: get('REACT_APP_COGNITO_RESPONSE'),
  REACT_APP_API_URL: get('REACT_APP_API_URL'),
  REACT_APP_PAYMENT_KEY: get('REACT_APP_PAYMENT_KEY'),
  REACT_APP_PAYMENT_LOCATION: get('REACT_APP_PAYMENT_LOCATION'),
  REACT_APP_BACKGROUND_IMG: get('REACT_APP_BACKGROUND_IMG'),
  REACT_APP_BACKGROUND_SIZE: get('REACT_APP_BACKGROUND_SIZE'),
  REACT_APP_NAME: get('REACT_APP_NAME'),
  REACT_APP_LOGO_IMG: get('REACT_APP_LOGO_IMG'),
  REACT_APP_FORM_URL: get('REACT_APP_FORM_URL'),
  REACT_APP_TEMPLATE_URL: get('REACT_APP_TEMPLATE_URL'),
  REACT_APP_TEMPLATE_API: get('REACT_APP_TEMPLATE_API'),
  REACT_APP_ESRI_KEY: get('REACT_APP_ESRI_KEY'),
  REACT_APP_STRIPE_PK: get('REACT_APP_STRIPE_PK'),
};

export default config;
